import $ from 'jquery';
import PerfectScrollbar from 'perfect-scrollbar';
import changeWindowUrl from './utils/change-url';
import debounce from './utils/debounce';

class ContentsList {
    constructor ($selector, $chapters, $pagination) {
        this.$document = $(document);
        this.$window = $(window);
        this.$body = $('body');
        this.$header = $('.js-header');
        this.$landingCover = $('.js-landing-cover');
        this.$contents = $('.js-contents');
        this.$contentsListButton = $('.js-contents-list-button');
        this.$subContentsListButton = $('.js-sub-list-button');
        this.$contentsList = $selector;
        this.$links = $selector.find('.js-contents-list__link');
        this.$subChapterLinks = $('.js-sub-contents-list__item');
        this.$chapters = $chapters;
        this.$pagination = $pagination;

        this.$window.on('load', $.proxy(this.init(), this));
        this.$window.on('scroll', $.proxy(this.displayOnScroll, this));
        this.$contentsListButton.on('click', $.proxy(this.contentsToggle, this));
        this.$subContentsListButton.on('click', $.proxy(this.subContentsToggle, this));
        this.$links.on('click', $.proxy(this.contentsClose, this));
        this.$subChapterLinks.on('click', $.proxy(this.contentsClose, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                if (this.$contentsList.hasClass('is-open')) {
                    this.contentsClose();
                }
            }
        });

        this.$window.on('resize', debounce(() => {
            this.updateScrollbars();
        }));

        // Scrollbar init
        this.scrollbars = [];
        this.addScrollbars();
    }

    /* #Scrollbar functions
================================================== */
    addScrollbars () {
        if (this.$contentsList.length) {
            this.scrollbars.push(new PerfectScrollbar(this.$contentsList[0]));
        }
    }

    destroyScrollbars () {
        this.scrollbars.forEach((ps) => ps.destroy());
    }

    updateScrollbars () {
        this.scrollbars.forEach((ps) => ps.update());
    }

    init () {
        this.$links.on('click', $.proxy(this.chapterClick, this));
        this.$pagination.on('click', $.proxy(this.setActiveClass, this));
        this.setActiveClass();
    }

    getCurrentChapter () {
        return this.$chapters.filter(function () {
            return ($(this).hasClass('is-current'));
        });
    }

    contentsToggle (e) {
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-clicked');
        this.$body.toggleClass('contents-list-open');
        this.$contentsList.slideToggle().toggleClass('is-open');

        if ($elem.hasClass('is-clicked')) {
            $elem.attr('aria-label', 'Close the chapter navigation');
        } else {
            $elem.attr('aria-label', 'Open the chapter navigation');
        }
    }

    contentsClose () {
        this.$contentsListButton.removeClass('is-clicked');
        this.$body.removeClass('contents-list-open');
        this.$contentsList.slideUp().removeClass('is-open');
    }

    subContentsToggle (e) {
        const $elem = $(e.currentTarget);
        const $elemParent = $elem.parents('.js-contents-list__item');

        $elem.toggleClass('is-clicked');
        $elemParent.toggleClass('is-open').find('.js-sub-contents-list').slideToggle().toggleClass('is-open');

        if ($elem.hasClass('is-clicked')) {
            $elem.attr('aria-label', 'Close the chapter sub-navigation');
        } else {
            $elem.attr('aria-label', 'Open the chapter sub-navigation');
        }
    }

    chapterClick (e) {
        e.preventDefault();

        const $elem = $(e.currentTarget);
        let chapterHash = $elem.attr('href');

        if (chapterHash) {
            chapterHash = chapterHash.toLowerCase().replace(/[?|&]preview=(\d+)/, '');
        }

        this.goTo($elem, chapterHash);
        this.setActiveClass();
    }

    setActiveClass () {
        const chapterID = this.getCurrentChapter().prop('id');

        this.$links.removeClass('is-active');
        this.$links.each(function () {
            const linkHref = $(this).attr('href');
            if (chapterID === linkHref) {
                $(this).addClass('is-active');
            }

            if ($(this).hasClass('is-active')) {
                setTimeout(() => {
                    $(this).next('.js-sub-list-button').trigger('click');
                }, 100);
            }
        });
    }

    goTo ($elem, chapterHash, changeUrl = true) {
        const headerHeight = this.$header.outerHeight(true);

        if (changeUrl) {
            changeWindowUrl(chapterHash, true, false);
        }

        if (chapterHash && $('#' + chapterHash).length) {
            let top = $('#' + chapterHash).offset().top;

            //for first chapter get the height of cover
            if (this.$header.length) {
                top = headerHeight;
            }

            if (this.$body.hasClass('is-landing-page')) {
                top += this.$landingCover.outerHeight(true);
            }

            $('html, body').animate({
                scrollTop: top - headerHeight,
            }, 400);
        }
    }

    displayOnScroll () {
        if (this.$window.scrollTop() > 128 || this.$contentsList.hasClass('is-open')) {
            this.$contents.addClass('is-visible');
        } else {
            this.$contents.removeClass('is-visible');
        }

    }
}

export default ContentsList;
